import { render, staticRenderFns } from "./DialogoTransferirEstoque.vue?vue&type=template&id=08317e44&"
import script from "./DialogoTransferirEstoque.vue?vue&type=script&lang=js&"
export * from "./DialogoTransferirEstoque.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports